// Routes des événements (lot L5-C1, M21), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageEvenement } from './PageEvenement';
import { PageEvenements } from './PageEvenements';

export const routesEvenements: RouteObject[] = [
  { path: '/evenements', element: <PageEvenements /> },
  { path: '/evenements/:id', element: <PageEvenement /> },
];
